import React, { useEffect, useState } from 'react';
import { api } from '../lib/api';
import { Card, CardContent } from './ui/card';
import { Store } from 'lucide-react';
import { money } from '../lib/share';

// Vista del propietario: todas las sucursales, total y separado
export const BranchSummary = () => {
  const [rows, setRows] = useState([]);
  useEffect(() => { api.getBranchesSummary().then((r) => setRows(r.data)).catch(() => {}); }, []);
  if (!rows.length) return null;
  const tot = (k) => rows.reduce((s, r) => s + (r[k] || 0), 0);
  return (
    <Card data-testid="branch-summary"><CardContent className="p-4">
      <h3 className="font-heading font-bold text-[#022C22] flex items-center gap-2 mb-3"><Store size={18} /> Sucursales · mes en curso</h3>
      <div className="overflow-x-auto"><table className="w-full text-sm">
        <thead><tr className="text-left text-xs text-[#64748B] border-b"><th className="py-2">Sucursal</th><th>Ventas mes</th><th>Por cobrar</th><th>Vencido</th><th>Clientes</th><th>Vendedores</th></tr></thead>
        <tbody>
          {rows.map((r) => <tr key={r.company_id} className="border-b border-[#F1F5F9]"><td className="py-2 font-medium">{r.name} <span className="text-[10px] text-[#94A3B8]">/{r.slug}</span></td><td>{money(r.month_sales)} ({r.month_count})</td><td>{money(r.receivable)}</td><td className="text-red-600">{money(r.overdue)}</td><td>{r.clients}</td><td>{r.sellers}</td></tr>)}
          <tr className="font-bold text-[#022C22]"><td className="py-2">TOTAL</td><td>{money(tot('month_sales'))}</td><td>{money(tot('receivable'))}</td><td className="text-red-600">{money(tot('overdue'))}</td><td>{tot('clients')}</td><td>{tot('sellers')}</td></tr>
        </tbody>
      </table></div>
    </CardContent></Card>
  );
};

export default BranchSummary;
